import LandingPageMetadata from '@/types/metadata/LandingPageMetadata';

/** Shape expected on `LOAD_CATEGORY_RESULTS_SUCCESS` payload for the landing-page reducer. */
export type LandingPageMetaDataPayload = {
    canonicalURL: string;
    label: string;
    metaDescription: string;
    metaKeywords: string;
    pageTitle: string;
    robots?: string;
};

/**
 * Search-party returns `landingPageMetadata` (array); the landing-page reducer reads
 * `landingPageMetaData` (singular). Pick the first entry with copy, else the first row.
 */
export const pickLandingPageMetaDataFromSearchPayload = (
    landingPageMetadata: LandingPageMetadata[] | undefined | null
): LandingPageMetaDataPayload | undefined => {
    if (!landingPageMetadata?.length) {
        return undefined;
    }

    const entry =
        landingPageMetadata.find((meta) => meta.pageTitle?.trim() || meta.label?.trim()) ?? landingPageMetadata[0];

    return {
        canonicalURL: entry.canonicalURL ?? '',
        label: entry.label ?? '',
        metaDescription: entry.metaDescription ?? '',
        metaKeywords: entry.metaKeywords ?? '',
        pageTitle: entry.pageTitle ?? '',
        robots: entry.robots,
    };
};
